import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hw_detail_table_container card-white-6" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("归类")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("关联产品")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "product_category_item_span" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_table_action = _resolveComponent("table-action")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_we_select = _resolveComponent("we-select")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_we_table, _mergeProps(_ctx.tableConfig, {
        dataSource: _ctx.products,
        onRegister: _ctx.register
      }), {
        name: _withCtx(({ text, record }) => [
          _createVNode(_component_a_button, {
            type: "link",
            onClick: ($event: any) => (_ctx.jumpToProduct(record))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(text), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        action: _withCtx(({ record }) => [
          _createVNode(_component_table_action, {
            actions: _ctx.handleTableActions(record)
          }, null, 8, ["actions"])
        ]),
        headerButton: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            class: "title_left_span_item",
            onClick: _ctx.edit_products_group
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            type: "primary",
            class: "title_left_span_item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.attachProduct()))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 16, ["dataSource", "onRegister"])
    ]),
    _createVNode(_component_a_modal, {
      centered: "",
      visible: _ctx.edit_products_category_visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.edit_products_category_visible) = $event)),
      onOk: _ctx.handle_edit_products_group,
      title: "分类",
      closable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { model: _ctx.products_category_form }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: [20, 20] }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "类名",
                      name: "category_id",
                      class: "category_form_item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.products_category_form.name_group,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.products_category_form.name_group) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "产品",
                      name: "product_ids"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_we_select, {
                          options: _ctx.product_list,
                          value: _ctx.products_category_form.product_ids,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.products_category_form.product_ids) = $event)),
                          mode: "multiple"
                        }, null, 8, ["options", "value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "onOk"]),
    _createVNode(_component_a_modal, {
      centered: "",
      visible: _ctx.edit_product_category_visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.edit_product_category_visible) = $event)),
      closable: false,
      title: "设置类名"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          ghost: "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.edit_product_category_visible = false))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product_category_list, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "product_category_item"
            }, [
              (!item.edit)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.name), 1))
                : (_openBlock(), _createBlock(_component_a_input, {
                    key: 1,
                    value: _ctx.product_category_list[index].name,
                    "onUpdate:value": ($event: any) => ((_ctx.product_category_list[index].name) = $event)
                  }, null, 8, ["value", "onUpdate:value"])),
              _createElementVNode("span", _hoisted_5, [
                (!item.edit)
                  ? (_openBlock(), _createBlock(_component_svg_icon, {
                      key: 0,
                      "icon-name": "EditOutlined",
                      style: {"color":"#4885ed"},
                      onClick: ($event: any) => (_ctx.product_category_list[index].edit = true),
                      class: "mr-8"
                    }, null, 8, ["onClick"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_svg_icon, {
                        "icon-name": "CheckOutlined",
                        style: {"color":"#4885ed"},
                        onClick: ($event: any) => (_ctx.edit_product_category(_ctx.product_category_list[index], 'edit')),
                        class: "mr-8"
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_svg_icon, {
                        "icon-name": "CloseOutlined",
                        onClick: ($event: any) => (_ctx.product_category_list[index].edit = false),
                        style: {"color":"#4885ed"},
                        class: "mr-8"
                      }, null, 8, ["onClick"])
                    ], 64)),
                _createVNode(_component_svg_icon, {
                  style: {"color":"#da296b"},
                  "icon-name": "DeleteOutlined",
                  onClick: ($event: any) => (_ctx.edit_product_category(_ctx.product_category_list[index], 'delete'))
                }, null, 8, ["onClick"])
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}